import {
  harnessIcon,
  harnessLabel,
  modelFundingLabel,
} from "@/constants/harnesses";
import {
  HarnessCapability,
  HarnessCapabilityModel,
} from "@cohesive/api-client";

/**
 * The content of a harness row and a model row — mark, label, the server's reason under an
 * unavailable harness, what a model is funded by. Shared by the composer's harness menu and the
 * rail footer's model menu, which wrap it in their own row register, so the two cannot drift on
 * what a harness looks like or says.
 */

export function HarnessIcon({ harness }: { harness: string }) {
  const Icon = harnessIcon(harness);
  return Icon ? <Icon className="size-4 shrink-0" /> : null;
}

export function HarnessRowLabel({
  capability,
}: {
  capability: HarnessCapability;
}) {
  return (
    <>
      <HarnessIcon harness={capability.id} />
      <div className="flex-1 min-w-0">
        <div className="truncate">
          {harnessLabel(capability.id, capability.label)}
        </div>
        {!capability.available && capability.unavailable_reason && (
          <div className="text-xs text-muted-foreground leading-snug">
            {capability.unavailable_reason}
          </div>
        )}
      </div>
    </>
  );
}

export function ModelRowLabel({ model }: { model: HarnessCapabilityModel }) {
  const funding = modelFundingLabel(model.funding);
  return (
    <>
      <div className="flex-1 min-w-0 truncate">{model.label}</div>
      {funding && (
        <span className="shrink-0 text-xs text-muted-foreground">
          {funding}
        </span>
      )}
    </>
  );
}
